/*
* @Author: hejianping
* @Date:   2018-05-29 18:03:51
* @Last Modified by:   UEDHE
* @Last Modified time: 2018-07-24 14:15:04
*/
export default {
  service: 'https://api.ptisp.daqsoft.com/govapi/api/',
  appid: 'wx22fc9ff90a3baa0',
  secrect: '955478bacd12bc3c1bfcb1ae0e78b274',
  lang: 'cn',
  siteCode: 'qdnzxw',
  region: 654301
}



// WEBPACK FOOTER //
// ./src/service/config.js